const { ajax } = require("jquery");
$.fn.dataTable.ext.errMode = 'none';

window.addEventListener("DOMContentLoaded", () => {
    window.datatablesPackageSale   = function datatablesPackageSale  (config) {
        const setDatatables = $("#setDatatables");
        const modalCall = $('#modalEdit');
        const subTitleModal = $('#sub_title_modal');

        if (!setDatatables.length) {
            return; // Saia da função se o elemento não existir
        }

        const materialDatatables = $(".materialDatatables");

        materialDatatables.css('display', 'block');

        const table = setDatatables.DataTable({
            responsive: true,
            dom: `<'row'<'col-10'r>><'row'<'col-5'l><'col-7 text-right'f>>' +<'row'<'col-sm-12'B>><'row'<'col-sm-12't>><'row'<'col-5'i><'col-7'p>>`,
            buttons: [],
            language: {
                url: "/js/jquery-datatables-pt-br.json",
            },
            lengthMenu: [
                [15, 25, 50, 100, -1],
                [15, 25, 50, 100, "Todos"],
            ],
        });

        table.order([1, "desc"]);
        table.on("click", ".remove", handleDeleteConfirmation);
        table.on('click', '.modalEdit', handleModalEdit);
        
        function handleDeleteConfirmation(e) {
            const $deleteButton = $(e.currentTarget);
           
            const id = $deleteButton.data('id');
          
                $.ajax({
                    method: 'get',
                    url: `/package_sales/${id}/package_buy`,
                    dataType: "JSON",
                    data: {
                        "id": id
                    }
                }).then((result) =>{
                    const percentage_regressive = result.data.package_buy.percentage_regressive;
                    const PACKAGEBUY = result.data.package_buy;
                    const PACKAGE_BUY_SERVICE_PRICES = result.data.services;
                    const MESSAGE = result.data.message;
                    const TITLE = result.data.title;

                    if(percentage_regressive > 0){
                        handleSwalFireForceDelete(e, PACKAGEBUY, PACKAGE_BUY_SERVICE_PRICES, MESSAGE, TITLE);
                    }
                    if(percentage_regressive == 100){
                        handleSwalDelete(e, PACKAGEBUY, PACKAGE_BUY_SERVICE_PRICES, MESSAGE, TITLE);
                    }
                    if(percentage_regressive == 0){
                        handleSwalDelete(e, PACKAGEBUY, PACKAGE_BUY_SERVICE_PRICES, MESSAGE, TITLE);
                    }
                    
                })          
        }
      
        function handleSwalFireForceDelete(e, PACKAGEBUY, PACKAGE_BUY_SERVICE_PRICES, MESSAGE, TITLE){

            const $deleteButton = $(e.currentTarget);
            const name = $deleteButton.data('name');
            const TUTOR = PACKAGEBUY.user.name;
            const PET = PACKAGEBUY.pet.name;
           
            let servicesHtml = '<table id="datatables" class="table table-bordered text-center"  width="100%">';
            servicesHtml += `
                <tr>
                    <th>Serviço</th>
                    <th>Disponível</th>
                    <th>Utilizado</th>
                </tr>
            `;
        
            $.each(PACKAGE_BUY_SERVICE_PRICES, function(index, servicePrice) {
                const serviceName = servicePrice.service.name;
                const serviceAvailable = servicePrice.available;
                const serviceUsed = servicePrice.used;
        
                servicesHtml += `
                    <tr>
                        <td>${serviceName}</td>
                        <td>${serviceAvailable}</td>
                        <td>${serviceUsed}</td>
                    </tr>
                `;
            });


            Swal.fire({
                title:`${TITLE}`,
                showCancelButton: true,
                html: `
                <p>Pacote: <strong>${name}</strong></p>
                <p>Tutor: <strong>${TUTOR}</strong> </p>
                <p>Pet: <strong>${PET}</strong> </p>
                    <p>${servicesHtml}</p>
                    <p>${MESSAGE}</p>
                    `,
                reverseButtons: true,
                width: 'fit-content',
                buttonsStyling: false,
                input: "checkbox",
                inputPlaceholder: `Este pacote esta em uso, deseja forçar a exclusão desta venda?`,
                confirmButtonClass: "btn btn-danger",
                cancelButtonClass: "btn btn-",
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const $tr = $deleteButton.closest("tr");
                        const id = $deleteButton.data('id');
                        const url = $deleteButton.data('url-remove');

                        // Determine checkbox value
                        const checkboxValue = result.value ? 1 : 0;
                        
                        const response = await $.ajax({
                            method: "DELETE",
                            url: url,
                            dataType: "JSON",
                            data: {
                                id: id,
                                forceDelete: checkboxValue,
                            },
                        });

                        if (!response.data) {
                            Swal.fire({
                                title: `Não foi possível excluir (${name})!`,
                                icon: "error",
                                text: response.message,
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false,
                            });
                            return;
                        }

                        table.row($tr).remove().draw();
                        Swal.fire({
                            title: "Excluído com sucesso",
                            icon: "success",
                            confirmButtonClass: "btn btn-success",
                            buttonsStyling: false,
                            timer: 3000,
                        });
                    } catch (error) {
                        handleDataTablesError(error);
                    }
                }
            });
        }

        function handleSwalDelete(e, PACKAGEBUY, PACKAGE_BUY_SERVICE_PRICES, MESSAGE, TITLE){
            
            const $deleteButton = $(e.currentTarget);
            const name = $deleteButton.data('name');
            const TUTOR = PACKAGEBUY.user.name;
            const PET = PACKAGEBUY.pet.name;
           
            let servicesHtml = '<table id="datatables" class="table table-bordered text-center"  width="100%">';
            servicesHtml += `
                <tr>
                    <th>Serviço</th>
                    <th>Disponível</th>
                    <th>Utilizado</th>
                </tr>
            `;
        
            $.each(PACKAGE_BUY_SERVICE_PRICES, function(index, servicePrice) {
                const serviceName = servicePrice.service.name;
                const serviceAvailable = servicePrice.available;
                const serviceUsed = servicePrice.used;
        
                servicesHtml += `
                    <tr>
                        <td>${serviceName}</td>
                        <td>${serviceAvailable}</td>
                        <td>${serviceUsed}</td>
                    </tr>
                `;
            });

            Swal.fire({
                title:`${TITLE}`,
                showCancelButton: true,
                html: `
                <p>Pacote: <strong>${name}</strong></p>
                <p>Tutor: <strong>${TUTOR}</strong> </p>
                <p>Pet: <strong>${PET}</strong> </p>
                <p>${servicesHtml}</p>
                <p>${MESSAGE}</p>
                `,
                width: 'fit-content',
                reverseButtons: true,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger",
                cancelButtonClass: "btn btn-",
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const $tr = $deleteButton.closest("tr");
                        const id = $deleteButton.data('id');
                        const url = $deleteButton.data('url-remove');

                        const response = await $.ajax({
                            method: "DELETE",
                            url: url,
                            dataType: "JSON",
                            data: {
                                id: id,
                            },
                        });

                        if (!response.data) {
                            Swal.fire({
                                title: `Não foi possível excluir (${name})!`,
                                icon: "error",
                                text: response.message,
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false,
                            });
                            return;
                        }

                        table.row($tr).remove().draw();
                        Swal.fire({
                            title: "Excluído com sucesso",
                            icon: "success",
                            confirmButtonClass: "btn btn-success",
                            buttonsStyling: false,
                            timer: 3000,
                        });
                    } catch (error) {
                        handleDataTablesError(error);
                    }
                }
            });
        }

        async function handleModalEdit() {
            const modalTitle = $(this).data('name');
            const url = $(this).data('url-modal');

            if (!url) {
                return; // Exit the function if url-modal doesn't exist
            }

            subTitleModal.text(modalTitle);

            modalCall.modal({
                backdrop: 'static',
                keyboard: false
            });

            try {
                const html = await $.get(url);
                modalCall.find('.modal-body').empty().append(html);
                modalCall.modal('show');
                if (config?.setScript) {
                    config.setScript();
                }
            } catch (error) {
                handleDataTablesError(error);
            }
        }

        function handleDataTablesError(error) {
            const response = error?.responseJSON;

            let title = "Ocorreu uma falha";
            if (response?.exception) {
                title = "Ocorreu uma falha";
            } else if (response?.errors && response?.message) {
                title = response.message;
            }

            Swal.fire({
                title: title,
                icon: "error",
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false,
            });
        }

    }
});
